import { Suspense, type ReactNode } from 'react';

/**
 * Wraps a lazy-loaded page so only the page area falls back to a loading
 * UI — the parent layout's chrome (sidebar, topbar, signup stepper) stays
 * mounted across navigations.
 *
 * Use inside any layout that renders <Outlet />:
 *
 *     <main>
 *         <PageSuspense><Outlet /></PageSuspense>
 *     </main>
 *
 * The fallback is deliberately empty (just a small inline hint) so brief
 * chunk loads under ~150ms don't visibly flash. Heavier loads still show
 * the "Loading…" line.
 */
export function PageSuspense({ children }: { children: ReactNode }) {
    return <Suspense fallback={<PageFallback />}>{children}</Suspense>;
}

function PageFallback() {
    return (
        <div className="flex h-full w-full items-start justify-center p-12 text-xs text-neutral-400">
            Loading…
        </div>
    );
}
